"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Document = function Document(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M81.982 34H58.987a2 2 0 0 1-2-2V7H16.999a2 2 0 0 0-2 2v78a2 2 0 0 0 2 2h62.984a2 2 0 0 0 2-2V34zm-2.06-7L63.987 10.177V27h15.937zm9.058 1.716c.013.093.02.188.02.284v5h-.02v60a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h53.126a2 2 0 0 1 1.452.625l23.854 25.18a2 2 0 0 1 .548 1.376v1.535z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Document;